import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../redux/reducers/authSlice';
import { VehicleService } from '../../../services/VehicleService';
import { GetVehicleListPagingAndFilterRequest, initialGetVehicleListPagingAndFilterRequest } from '../../../models/request/vehicle/GetVehicleListPagingAndFilterRequest';
import TableFooter from '../../../components/TableFooter';
import { GetVehicleListPagingAndFilterResponse, GetVehicleListPagingAndFilterResponseData, GetVehicleListPagingAndFilterResponseItem, initialGetVehicleListPagingAndFilterResponseData } from '../../../models/response/vehicle/GetVehicleListPagingAndFilterResponse';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import VehicleListFilters from './Components/VehicleListFilters';
import { GetCompanyListResponse, GetCompanyListResponseItem } from '../../../models/response/company/GetCompanyListResponse';
import { CompanyService } from '../../../services/CompanyService';
import { CustomSingleSelectModel } from '../../../components/CustomSingleSelect';
import { GetConstantListResponse } from '../../../models/response/constant/GetConstantListResponse';
import { ConstantService } from '../../../services/ConstantService';
import { DeleteVehicleResponse } from '../../../models/response/vehicle/DeleteVehicleResponse';
import { ExportVehicleListResponse } from '../../../models/response/vehicle/ExportVehicleListResponse';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadConstants, loadList, YES_NO_FILTER } from '../../../components/ColumnFilter/columnFilterOptions';
import StatusBadge from '../../../components/StatusBadge';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { qrYazdir } from '../../../components/QrEtiket/qrYazdir';

const VehicleList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Genel Tanımlamalar > Araç Tanımları"
    // Surum 4 (06.10.2026): Arac Resmi kolonu kaldirildi; eski kolon secici ayari sifirlansin.
    const pageVersion = "4";
    const [data, setData] = useState<GetVehicleListPagingAndFilterResponseData>(initialGetVehicleListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetVehicleListPagingAndFilterRequest>(initialGetVehicleListPagingAndFilterRequest)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Araç Plaka', name: 'plate', order: 0, isVisible: true },
            { title: 'Treyler Plaka', name: 'trailerName', order: 0, isVisible: true },
            { title: 'Araç Durumu', name: 'vehicleStatusName', order: 0, isVisible: true },
            { title: 'Araç Sahibi', name: 'vehicleOwnerName', order: 0, isVisible: true },
            { title: 'Araç Cinsi', name: 'vehicleTypeName', order: 0, isVisible: true },
            { title: 'Araç Cinsi 2', name: 'vehicleType2Name', order: 0, isVisible: true },
            { title: 'Marka', name: 'brandName', order: 0, isVisible: true },
            { title: 'Model', name: 'brandDetailName', order: 0, isVisible: true },
            { title: 'Model Yılı', name: 'modelYear', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Aktif', name: 'isCustomActive', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteVehicle = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.vehicleId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteVehicleResponse = await VehicleService.deleteVehicle(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateVehicle = async (_id: string | undefined = undefined) => {
        navigate('/vehicle/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].vehicleId));
    }

    // Seçilen araçların QR etiketlerini yazdırır (11.10.2026). Kodu olmayan araç için backend üretir.
    const qrYazdirSecilenler = async () => {
        var selectedIds = data.items.filter(x => x.isSelected).map(x => x.vehicleId);

        if (selectedIds.length == 0) {
            toast.error('Yazdırılacak satırları seçin');
            return;
        }

        try {
            dispatch(storeActivityIndicator(true))

            var response = await VehicleService.qrKodlari(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message ?? '')
                return;
            }

            qrYazdir(response.data.map(x => ({ baslik: x.plaka, qrMetni: x.qrMetni, qrKodu: x.qrKodu })));
        } catch (error: any) {
            toast.error(error)
        } finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetVehicleListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetVehicleListPagingAndFilterResponse = await VehicleService.getVehicleListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.vehicleId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.length == data.items.filter(x => x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportVehicleListResponse = await VehicleService.exportVehicleList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.vehicleId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Araç resmi (görsel) ve marka
    // (model kaydının üst kaydından türetiliyor) sıralama dışında bırakıldı.
    const sortableColumns = [
        'plate', 'trailerName', 'vehicleStatusName', 'vehicleOwnerName',
        'vehicleTypeName', 'vehicleType2Name', 'brandDetailName', 'modelYear', 'isCustomActive',
        'createdUser', 'updatedUser'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (VehicleManager.ApplyColumnFilters) aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        // Araç Resmi filtresiz (görsel).
        plate: { type: 'text' },
        trailerName: { type: 'text' },
        vehicleStatusName: { type: 'select', loadOptions: () => loadConstants('VEHICLE_STATUS'), renderOption: (label) => <StatusBadge text={label} /> },
        vehicleOwnerName: { type: 'select', loadOptions: () => loadList(CompanyService.getCompanyList({ isSupplier: true }), 'companyId', x => x.name) },
        vehicleTypeName: { type: 'select', loadOptions: () => loadConstants('VEHICLE_TYPE') },
        // Araç Cinsi 2 boş olabilir: "(Boş)" seçimi girilmemiş kayıtları süzer.
        vehicleType2Name: { type: 'select', loadOptions: () => loadConstants('VEHICLE_TYPE_2') },
        // Marka, modelin üst kaydı; seçilen markanın tüm modellerindeki araçlar gelir.
        brandName: { type: 'select', loadOptions: () => loadConstants('VEHICLE_BRAND') },
        brandDetailName: { type: 'select', loadOptions: () => loadConstants('VEHICLE_BRAND_DETAIL') },
        modelYear: { type: 'number' },
        isCustomActive: YES_NO_FILTER,
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetVehicleListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "isCustomActive") {
            return (
                <td className={className} onClick={() => setItemSelected(item.vehicleId)} onDoubleClick={() => updateVehicle(item.vehicleId)}><StatusBadge text={item.isCustomActive ? "Evet" : "Hayır"} /></td>
            )
        }
        else if (column == "vehicleStatusName") {
            return (
                <td className={className} onClick={() => setItemSelected(item.vehicleId)} onDoubleClick={() => updateVehicle(item.vehicleId)}><StatusBadge text={item.vehicleStatusName} /></td>
            )
        }
        else if (column == "createdUser") {
            return (
                <td className={className} onClick={() => setItemSelected(item.vehicleId)} onDoubleClick={() => updateVehicle(item.vehicleId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={() => setItemSelected(item.vehicleId)} onDoubleClick={() => updateVehicle(item.vehicleId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={() => setItemSelected(item.vehicleId)} onDoubleClick={() => updateVehicle(item.vehicleId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <VehicleListFilters
                    columns={columns}
                    excelExport={excelExport}
                    filter={filter}
                    getColumns={getColumns}
                    getData={getData}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteVehicle}
                    updateFunction={updateVehicle}
                    onSearchSubmit={onSearchSubmit}
                    qrYazdirFunction={qrYazdirSecilenler}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.vehicleId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default VehicleList;